import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../../Common/Configurations/AuthContext";
import config from "../../../Common/Configurations/APIConfig";
import apiService from "../../../Common/Configurations/APIService";
import Header from "../../../Common/Layout/Header";
import {
  RiArrowLeftLine,
  RiCheckboxCircleLine,
  RiBusLine,
  RiUserLine,
  RiMapPinLine,
  RiShieldLine,
  RiTimeLine,
  RiLockUnlockLine,
  RiAlertFill,
} from "react-icons/ri";
import styles from "../BusPayment/BusPayment1.module.css";

const BusPayment1 = ({ mode, onNavigate, templateId, params, styleConfig }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();
   const themeVariables = {
    "--primary-color": styleConfig?.primary || "#3b82f6",
    "--secondary-color": styleConfig?.secondary || "#8b5cf6",
  };

  // 👇 3. READ FROM PARAMS (For Builder) OR LOCATION (For Live)
   const {
    bus, searchQuery, selectedSeats, passengerCount, passengerDetails, selectedBoardingPoint, selectedDroppingPoint,
  } = params || location.state || {};





  const [isProcessingPayment, setIsProcessingPayment] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("RAZORPAY");
  const [showPaymentMethods, setShowPaymentMethods] = useState(false);

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      const day = date.getDate().toString().padStart(2, "0");
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const month = monthNames[date.getMonth()];
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    } catch (error) {
      return dateString;
    }
  };

  // Format time
  const formatTime = (timeStr) => {
    if (!timeStr) return "";
    const [hours, minutes] = timeStr.split(":");
    const hour = parseInt(hours);
    const ampm = hour >= 12 ? "PM" : "AM";
    const displayHour = hour % 12 || 12;
    return `${displayHour}:${minutes} ${ampm}`;
  };

  // Redirect if no booking data
// FIND THIS IN BusPayment1.jsx AND REPLACE IT:

  // Redirect if missing data
  useEffect(() => {
    if (!bus || !searchQuery || !selectedSeats?.length || !passengerDetails?.length) {
      if (mode === "builder") {
        onNavigate({ name: "bus-results" });
      } else if (mode === "preview") {
        navigate(`/template-preview/${templateId}/bus-results`);
      } else {
        navigate("/template/bus/results");
      }
    }
  },[bus, searchQuery, selectedSeats, passengerDetails, navigate, mode, onNavigate, templateId]);

   if (!bus || !searchQuery || !selectedSeats?.length || !passengerDetails?.length) {
    return (
      <div className={styles.wrapper} style={themeVariables}>
       
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '70vh' }}>
          <div style={{ textAlign: 'center', padding: '40px', background: 'white', borderRadius: '20px', boxShadow: '0 10px 25px rgba(0,0,0,0.1)' }}>
            <RiAlertFill style={{ fontSize: '4rem', color: '#ef4444', marginBottom: '20px', margin: '0 auto' }} />
            <h2 style={{ marginBottom: '10px', color: '#1e293b' }}>Booking Session Expired</h2>
            <p style={{ color: '#64748b', marginBottom: '20px' }}>Your booking details were lost or the session timed out.</p>
            <button 
              onClick={() => mode === 'preview' ? navigate(`/template-preview/${templateId}/bus-search`) : navigate('/template/bus-search')}
              style={{ padding: '10px 24px', background: 'var(--primary-color, #3b82f6)', color: 'white', border: 'none', borderRadius: '30px', cursor: 'pointer', fontWeight: '600' }}
            >
              Go Back to Search
            </button>
          </div>
        </div>
      </div>
    );
  }
  const formatCurrency = (amount) => {
    const num = parseFloat(amount) || 0;
    return `₹${Math.round(num).toLocaleString("en-IN")}`;
  };

  const calculateBreakdown = () => {
    if (!selectedSeats) return { baseFare: 0, convenienceFee: 0, total: 0 };

    const base = selectedSeats.reduce(
      (sum, seat) => sum + (parseFloat(seat.totalPriceWithTaxes) || 0),
      0
    );
    const convenience = selectedSeats.reduce(
      (sum, seat) => sum + (parseFloat(seat.convenienceFee) || 100),
      0
    );
    const total = base + convenience;

    return {
      baseFare: base,
      convenienceFee: convenience,
      total,
    };
  };

  // Build booking request data
  const buildBookingRequest = () => {
    const baseFare = selectedSeats.reduce(
      (sum, seat) => sum + (parseFloat(seat.totalPriceWithTaxes) || 0),
      0
    );

    const convenienceFee = selectedSeats.reduce(
      (sum, seat) => sum + (parseFloat(seat.convenienceFee) || 100),
      0
    );

    const totalFare = baseFare;
    const totalPrice = baseFare + convenienceFee;
    const gst = 18;
    const gstAmount = convenienceFee * (gst / 100);

    return {
      CompanyId: user?.cid || "00000000-0000-0000-0000-000000000000",
      BranchId: user?.branchId || "00000000-0000-0000-0000-000000000000",
      UserId: user?.id || "00000000-0000-0000-0000-000000000000",
      CustomerId: user?.customerId || "00000000-0000-0000-0000-000000000000",
      SupplierId: bus.supplierId,
      SourceCity: searchQuery.fromStation,
      DestinationCity: searchQuery.toStation,
      InventoryType: bus.inventoryType,
      RouteScheduleId: bus.routeScheduleId,
      BusType: bus.busType,
      OperatorName: bus.operatorName,
      JourneyType: "ONE_WAY",
      RequestedBy: "CUSTOMER",

      // Fare details
      BaseFare: baseFare,
      Tax: selectedSeats.reduce(
        (sum, seat) => sum + (parseFloat(seat.serviceTaxAmount) || 0),
        0
      ),
      ConvenienceFee: convenienceFee,
      GST: gst,
      GSTAmount: gstAmount,
      TotalFare: totalFare,
      TotalPrice: totalPrice,
      Markup: 0,

      // Customer information
      CustomerName: `${passengerDetails[0].firstName} ${passengerDetails[0].lastName}`,
      CustomerLastName: passengerDetails[0].lastName || "",
      CustomerEmail: passengerDetails[0].email,
      DOJ: new Date(searchQuery.travelDate),

      // Points
      BoardingPoint: {
        Id: selectedBoardingPoint.id,
        Location: selectedBoardingPoint.location,
        Time: selectedBoardingPoint.time,
      },
      DroppingPoint: {
        Id: selectedDroppingPoint.id,
        Location: selectedDroppingPoint.location,
        Time: selectedDroppingPoint.time,
      },

      CustomerPhone: passengerDetails[0].phone,
      EmergencyPhNumber: passengerDetails[0].phone,
      CustomerAddress: "Not provided",

      // Status
      IsHold: false,
      BookingStatus: "BOOKED",
      PaymentStatus: "SUCCESS",

      // Payment information
      PaymentGatewayAmount: totalPrice,
      WalletAmount: 0,
      CreditAmount: 0,
      PaymentGateway: paymentMethod,
      CouponCode: "",

      // Passenger details
      BookSeatPaxDetails: selectedSeats.map((seat, index) => {
        const passenger = passengerDetails[index] || passengerDetails[0];
        const seatBaseFare = parseFloat(seat.totalPriceWithTaxes) || 0;
        const seatConvFee = parseFloat(seat.convenienceFee) || 100;

        return {
          Age: passenger.age,
          Name: `${passenger.firstName} ${passenger.lastName}`,
          SeatNbr: seat.id,
          Sex:
            passenger.title === "Ms" || passenger.title === "Mrs" ? "F" : "M",
          Fare: seatBaseFare,
          ServiceTaxAmount: seat.serviceTaxAmount || 0,
          OperatorServiceChargeAbsolute: seatConvFee,
          TotalFareWithTaxes: seatBaseFare,
          LadiesSeat: seat.ladiesSeat || false,
          LastName: passenger.lastName || "",
          Mobile: passenger.phone,
          Title: passenger.title,
          Email: passenger.email,
          IdType: passenger.idProof,
          IdNumber: passenger.idProofNumber || "",
          NameOnId: `${passenger.firstName} ${passenger.lastName}`,
          Primary: index === 0,
          Ac: seat.ac || false,
          Sleeper: seat.sleeper || false,
        };
      }),
    };
  };
 
  // Function to book directly (with payment)
  const handlePayment = async () => {
    setIsProcessingPayment(true);
    const res = await loadRazorpayScript();

    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      setIsProcessingPayment(false);
      return;
    }

    try {
      const breakdown = calculateBreakdown();
      const finalAmount = breakdown.total * 100;

      // 1. Create payment order
      const paymentResult = await apiService.post(
        `${config.MAKEPAYMENT}?Amount=${breakdown.total}&PayRequest=${paymentMethod}&CompanyId=${user?.cid}`
      );

      if (!paymentResult.succeeded) {
        alert("Payment initiation failed. Please try again.");
        setIsProcessingPayment(false);
        return;
      }

      const { id: order_id, currency, razorpayKey, name } = paymentResult.data;

      const options = {
        key: razorpayKey,
        amount: finalAmount,
        currency: currency,
        name: name,
        description: `Bus Booking - ${bus.operatorName} | ${searchQuery.fromStation} to ${searchQuery.toStation}`,
        order_id: order_id,
        handler: async function (paymentResponse) {
          try {
            // 2. Book seats after payment success
            const bookRequest = buildBookingRequest();
            bookRequest.PaymentReference = {
              paymentId: paymentResponse.razorpay_payment_id,
              orderId: paymentResponse.razorpay_order_id,
              signature: paymentResponse.razorpay_signature,
            };

            const bookResponse = await apiService.post(
              config.BOOKBUSSEATS,
              bookRequest
            );

            if (bookResponse && bookResponse.apiStatus?.success) {
              navigateToConfirmation("CONFIRMED", {
                bookingId: bookResponse.bookingId,
                bookingNo: bookResponse.bookingNo,
                invoiceNo: bookResponse.invoiceNo,
                supplierBookingId: bookResponse.supplierBookingId,
                pnr: bookResponse.pnr,
                bookTicketKey: bookResponse.bookTicketKey,
                saleInvoiceNumber: bookResponse.saleInvoiceNumber,
                purchaseInvoiceNumber: bookResponse.purchaseInvoiceNumber,
                paymentId: paymentResponse.razorpay_payment_id,
                orderId: paymentResponse.razorpay_order_id,
                message: "Booking confirmed successfully!",
              });
            } else {
              navigateToConfirmation("PAYMENT_SUCCESS_BOOKING_FAILED", {
                paymentId: paymentResponse.razorpay_payment_id,
                orderId: paymentResponse.razorpay_order_id,
                amount: breakdown.total,
                errorMessage: `Payment successful but booking failed: ${bookResponse?.apiStatus?.message}`,
              });
            }
          } catch (error) {
            console.error("Booking error:", error);
            navigateToConfirmation("PAYMENT_SUCCESS_BOOKING_PENDING", {
              paymentId: paymentResponse.razorpay_payment_id,
              orderId: paymentResponse.razorpay_order_id,
              amount: breakdown.total,
              message:
                "Payment successful! Please contact support for booking confirmation.",
            });
          }
        },
        prefill: {
          email: user?.email || passengerDetails[0]?.email,
          contact: user?.phoneNumber || passengerDetails[0]?.phone,
          name: `${passengerDetails[0]?.firstName} ${passengerDetails[0]?.lastName}`,
        },
        notes: {
          bookingType: "BUS_DIRECT_BOOKING",
          fromStation: searchQuery.fromStation,
          toStation: searchQuery.toStation,
          travelDate: formatDate(searchQuery.travelDate),
          passengerCount: passengerCount,
          seats: selectedSeats.map((s) => s.id).join(","),
        },
        theme: {
          color: "#3399cc",
        },
      };

      const paymentObject = new window.Razorpay(options);

      paymentObject.on("payment.failed", function (response) {
        console.error("Payment failed:", response.error);
        setIsProcessingPayment(false);
        navigateToConfirmation("PAYMENT_FAILED", {
          errorMessage: `Payment failed: ${response.error.description}`,
          errorCode: response.error.code,
        });
      });

      paymentObject.on("payment.cancel", function (response) {
        console.log("Payment cancelled by user:", response);
        setIsProcessingPayment(false);
        navigateToConfirmation("PAYMENT_CANCELLED", {
          message: "Payment was cancelled.",
        });
      });

      paymentObject.open();
    } catch (error) {
      console.error("Payment error:", error);
      alert("Payment initiation failed. Please try again.");
      setIsProcessingPayment(false);
    }
  };

  // Load Razorpay script
  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      if (window.Razorpay) {
        resolve(true);
        return;
      }

      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  // Navigate to confirmation screen
  // REPACE THIS FUNCTION IN BusPayment1.jsx
  const navigateToConfirmation = (status, bookingData = {}) => {
    const breakdown = calculateBreakdown();

    const confirmationData = {
      bus,
      searchQuery,
      selectedSeats,
      passengerCount,
      passengerDetails,
      selectedBoardingPoint,
      selectedDroppingPoint,
      totalAmount: breakdown.total,
      baseFare: breakdown.baseFare,
      convenienceFee: breakdown.convenienceFee,
      bookingStatus: status,
      ...bookingData,
    };

     if (mode === "builder") {
      onNavigate({ name: "bus-booking-confirmation", params: confirmationData });
    } else if (mode === "preview") {
      // 👇 FIX: Use hyphen (-), NOT slash (/)
      navigate(`/template-preview/${templateId}/bus-booking-confirmation`, { state: confirmationData });
    } else {
      // 👇 FIX: Use hyphen (-), NOT slash (/)
      navigate("/template/bus-booking-confirmation", { state: confirmationData });
    }
  };

  const handleBackToSeats = () => {
    // 👇 BACK BUTTON LOGIC
    if (mode === "builder") {
      onNavigate({ name: "bus-seats", params: { bus, searchQuery } });
    } else {
      navigate(-1);
    }
  };

  const breakdown = calculateBreakdown();

  return (
      <div className={styles.wrapper} style={themeVariables}>
     
      <div className={styles.mainContent}>
        <div className={styles.container}>
          {/* Page Header */}
          <div className={styles.pageHeader}>
            <div>
              <h1 className={styles.pageTitle}>Complete Your Booking</h1>
              <p className={styles.pageSubtitle}>
                Review details and proceed to payment
              </p>
            </div>
            <button
              className={styles.backButton}
              onClick={handleBackToSeats}
            >
              <RiArrowLeftLine />
              Back to Seats
            </button>
          </div>

          <div className={styles.contentGrid}>
            {/* Left Column - Booking Details */}
            <div className={styles.mainColumn}>
              {/* Journey Details */}
              <div className={styles.card}>
                <div className={styles.cardHeader}>
                  <RiBusLine className={styles.cardIcon} />
                  <h3>Journey Details</h3>
                </div>
                <div className={styles.cardBody}>
                  <div className={styles.journeyGrid}>
                    <div className={styles.journeyItem}>
                      <span className={styles.journeyLabel}>Route</span>
                      <span className={styles.journeyValue}>
                        {searchQuery.fromStation} → {searchQuery.toStation}
                      </span>
                    </div>
                    <div className={styles.journeyItem}>
                      <span className={styles.journeyLabel}>Travel Date</span>
                      <span className={styles.journeyValue}>
                        {formatDate(searchQuery.travelDate)}
                      </span>
                    </div>
                    <div className={styles.journeyItem}>
                      <span className={styles.journeyLabel}>Operator</span>
                      <span className={styles.journeyValue}>{bus.operatorName}</span>
                    </div>
                    <div className={styles.journeyItem}>
                      <span className={styles.journeyLabel}>Departure</span>
                      <span className={styles.journeyValue}>
                        {formatTime(bus.departureTime)}
                      </span>
                    </div>
                    <div className={styles.journeyItem}>
                      <span className={styles.journeyLabel}>Arrival</span>
                      <span className={styles.journeyValue}>
                        {formatTime(bus.arrivalTime)}
                      </span>
                    </div>
                    <div className={styles.journeyItem}>
                      <span className={styles.journeyLabel}>Bus Type</span>
                      <span className={styles.journeyValue}>{bus.busType}</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Passenger Details */}
              <div className={styles.card}>
                <div className={styles.cardHeader}>
                  <RiUserLine className={styles.cardIcon} />
                  <h3>Passenger Details ({passengerCount})</h3>
                </div>
                <div className={styles.cardBody}>
                  <div className={styles.tableWrapper}>
                    <table className={styles.passengerTable}>
                      <thead>
                        <tr>
                          <th>Passenger</th>
                          <th>Seat</th>
                          <th>Age</th>
                          <th>ID Proof</th>
                          <th>Contact</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedSeats.map((seat, index) => {
                          const passenger =
                            passengerDetails[index] || passengerDetails[0];
                          return (
                            <tr key={seat.id}>
                              <td>
                                <strong>
                                  {passenger.title} {passenger.firstName}{" "}
                                  {passenger.lastName}
                                </strong>
                              </td>
                              <td>
                                <span className={styles.seatBadge}>
                                  {seat.id}
                                </span>
                              </td>
                              <td>{passenger.age} years</td>
                              <td>{passenger.idProof}</td>
                              <td>
                                <div>{passenger.phone}</div>
                                <small className={styles.textMuted}>
                                  {passenger.email}
                                </small>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* Boarding Points */}
              <div className={styles.card}>
                <div className={styles.cardHeader}>
                  <RiMapPinLine className={styles.cardIcon} />
                  <h3>Boarding & Dropping Points</h3>
                </div>
                <div className={styles.cardBody}>
                  <div className={styles.pointsGrid}>
                    <div className={styles.pointCard}>
                      <h4 className={styles.pointTitle}>Boarding Point</h4>
                      <p className={styles.pointLocation}>
                        <strong>{selectedBoardingPoint?.location}</strong>
                      </p>
                      <p className={styles.pointTime}>
                        <RiTimeLine />
                        {formatTime(selectedBoardingPoint?.time)}
                      </p>
                      <small className={styles.textMuted}>
                        {selectedBoardingPoint?.pointName ||
                          selectedBoardingPoint?.location}
                      </small>
                    </div>
                    <div className={styles.pointCard}>
                      <h4 className={styles.pointTitle}>Dropping Point</h4>
                      <p className={styles.pointLocation}>
                        <strong>{selectedDroppingPoint?.location}</strong>
                      </p>
                      <p className={styles.pointTime}>
                        <RiTimeLine />
                        {formatTime(selectedDroppingPoint?.time)}
                      </p>
                      <small className={styles.textMuted}>
                        {selectedDroppingPoint?.pointName ||
                          selectedDroppingPoint?.location}
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column - Payment Summary */}
            <div className={styles.sidebar}>
              <div className={styles.paymentCard}>
                <div className={styles.paymentHeader}>
                  <h3>Payment Summary</h3>
                </div>
                <div className={styles.paymentBody}>
                  {/* Fare Breakdown */}
                  <div className={styles.fareBreakdown}>
                    <div className={styles.fareItem}>
                      <span>Bus Fare</span>
                      <span>{formatCurrency(breakdown.baseFare)}</span>
                    </div>
                    <div className={styles.fareItem}>
                      <div>
                        <span>Convenience Fee</span>
                        <small className={styles.fareNote}>
                          ₹100 per seat × {passengerCount}
                        </small>
                      </div>
                      <span>{formatCurrency(breakdown.convenienceFee)}</span>
                    </div>

                    <div className={styles.fareDivider}></div>

                    <div className={`${styles.fareItem} ${styles.total}`}>
                      <span>Total Amount</span>
                      <span className={styles.totalAmount}>
                        {formatCurrency(breakdown.total)}
                      </span>
                    </div>
                  </div>

                  {/* Payment Method Selection */}
                  <div className={styles.paymentMethodSection}>
                    <button
                      className={styles.paymentMethodButton}
                      onClick={() => setShowPaymentMethods(!showPaymentMethods)}
                    >
                      <RiShieldLine />
                      <span>Payment Method</span>
                      <span className={styles.paymentMethodValue}>{paymentMethod}</span>
                    </button>

                    {showPaymentMethods && (
                      <div className={styles.paymentMethodsDropdown}>
                        <label className={styles.radioOption}>
                          <input
                            type="radio"
                            name="paymentMethod"
                            value="RAZORPAY"
                            checked={paymentMethod === "RAZORPAY"}
                            onChange={(e) => setPaymentMethod(e.target.value)}
                          />
                          <span>Razorpay (Credit/Debit Card, UPI, Net Banking)</span>
                        </label>
                        <label className={styles.radioOption}>
                          <input
                            type="radio"
                            name="paymentMethod"
                            value="WALLET"
                            checked={paymentMethod === "WALLET"}
                            onChange={(e) => setPaymentMethod(e.target.value)}
                          />
                          <span>Wallet Balance</span>
                        </label>
                      </div>
                    )}
                  </div>

                  {/* Pay Button */}
                  <button
                    className={styles.payButton}
                    onClick={handlePayment}
                    disabled={isProcessingPayment}
                  >
                    {isProcessingPayment ? (
                      <>
                        <span className={styles.spinner}></span>
                        Processing...
                      </>
                    ) : (
                      <>
                        <RiLockUnlockLine />
                        Pay {formatCurrency(breakdown.total)}
                      </>
                    )}
                  </button>

                  {/* Security Badge */}
                  <div className={styles.securityBadge}>
                    <RiShieldLine />
                    <span>Secure & Encrypted Payment</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusPayment1;